import { styled } from 'goober';

export const Container = styled('div')`
  position: relative;
  height: 510px;
  @media only screen and (max-width: 600px) {
    height: 310px;
  }
`;
const WhatItIsText = styled('div')`
  padding-top: 36px;
  font-size: 25px;
  font-weight: 500;
  line-height: 38px;
  font-style: normal;
  color: #949494;
  margin-top: 0;
  @media only screen and (max-width: 600px) {
    font-size: 20px;
    line-height: 30px;
    margin-top: 0;
    padding-top: 16px;
  }
`;
const TitleText = styled('div')`
  width: 450px;
  margin-bottom: 0;
  font-style: normal;
  font-size: 30px;
  font-weight: 600;
  line-height: 35px;
  margin-top: 20px;
  color: #00733b;
  @media only screen and (max-width: 600px) {
    width: 254px;
    font-size: 18px;
    line-height: 22px;
  }
`;
const ActivateCreditLine = styled('div')`
  width: 376px;
  height: fit-content;
  background: #ecfff1;
  border-radius: 8px;
  margin-top: 28px;
  padding: 12px 24px 15px 13px;
  @media only screen and (max-width: 600px) {
    width: 208px;
    margin-top: 23px;
    padding: 2px 24px 4px 8px;
  }
`;
const ActivateCreditLineText = styled('p')`
  width: 339px;
  height: 41px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #04581b;
  margin-top: 0;
  margin-bottom: 0;
  @media only screen and (max-width: 600px) {
    font-size: 12px;
    line-height: 17px;
    width: 176px;
  }
`;
const ShopNowTextContainer = styled('div')`
  width: 255px;
  height: fit-content;
  background: #ecfff1;
  border-radius: 8px;
  margin-top: 17px;
  padding: 12px 24px 15px 13px;
  @media only screen and (max-width: 600px) {
    width: 158px;
    margin-top: 16px;
    padding: 2px 27px 7px 6px;
  }
`;
const ShopNowText = styled('p')`
  width: 233px;
  height: fit-content;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #04581b;
  margin-top: 0;
  margin-bottom: 0;
  @media only screen and (max-width: 600px) {
    width: 125px;
    height: 44px;
    font-size: 12px;
    line-height: 15px;
  }
`;
const ImageContainerForSlides = styled('div')`
  margin-top: 4px;
  position: absolute;
  bottom: 0;
  right: 10px;
  width: 196px;
  height: 245px;
  @media only screen and (max-width: 600px) {
    width: 39%;
    height: 35vw;
  }
`;
export const ImageForSlides = styled('div')`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  @media only screen and (max-width: 600px) {
    background-size: contain;
  }
`;
const SlideOne = () => {
  return (
    <Container>
      <WhatItIsText> What is it? </WhatItIsText>
      <TitleText> Buy Now Pay Later with Cardless EMI </TitleText>
      <ActivateCreditLine>
        <ActivateCreditLineText>
          Available across 2 lakh+ merchants
        </ActivateCreditLineText>
      </ActivateCreditLine>

      <ShopNowTextContainer>
        <ShopNowText>
          Cardless EMI is provided by our partner Bank/NBFCs.
        </ShopNowText>
      </ShopNowTextContainer>

      <ImageContainerForSlides>
        <ImageForSlides
          style={{
            backgroundImage:
              "url('https://iccdn.in/img/edu_modal_hero_image1.png')",
          }}
        />
      </ImageContainerForSlides>
    </Container>
  );
};
export default SlideOne;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/educationalModal/slideOne.js